import { ITile } from 'types/src/types';
import { supabase } from '../lib/supabase/client';

export async function updateTileOrderClient(
  tiles: Partial<ITile>[],
  onlyCoordinates = false,
  signal?: AbortSignal
) {
  const session = await supabase.auth.getSession();
  const token = session.data.session?.access_token;
  if (!token) {
    return { data: null, error: 'No authentication token found' };
  }

  const url = `${process.env.NEXT_PUBLIC_SUPABASE_URL}/functions/v1/tiles?onlyCoordinates=${onlyCoordinates}`;

  const res = await fetch(url, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(tiles),
    signal,
  });

  if (!res.ok) {
    console.error('Error updating tile order:', res);
    const errorText = await res.text();
    throw new Error(`Error updating tile order: ${errorText}`);
  }

  return await res.json();
}
